import React from 'react';

export const GamesSection: React.FC = () => {
    return (
        <section className="max-w-7xl mx-auto px-6 mb-24 scroll-mt-24">
            
            {/* Section Header */}
            <div className="flex items-center gap-3 mb-8">
                <div className="w-3 h-8 rounded-full bg-purple-500"></div>
                <h2 className="text-2xl font-bold text-white uppercase tracking-wider">Juegos</h2>
            </div>

            {/* Games Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                
                {/* Game Card: Quizz */}
                <div className="flex flex-col items-center text-center gap-6 bg-[#1e293b]/50 p-8 rounded-3xl border border-white/5 backdrop-blur-sm transition-all duration-300 hover:border-white/10 hover:bg-[#1e293b]/80">
                    <div className="relative">
                        <img 
                            src="/logosec.jpeg" 
                            alt="Logo Quizz" 
                            className="w-32 h-32 object-cover rounded-2xl shadow-2xl border border-white/10"
                        />
                        <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-white/10 pointer-events-none"></div>
                    </div>

                    <div className="flex-1">
                        <h3 className="text-xl font-bold text-white tracking-tight mb-2">Quizz de videojuegos</h3>
                        <p className="text-slate-400 text-sm">
                            Demuestra tus conocimientos y diviértete con nuestra selección de preguntas.
                        </p>
                    </div>

                    <div className="w-full mt-4">
                        <a 
                            href="http://quizzjuegos.gamesjrztwo.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex w-full items-center justify-center bg-blue-600 hover:bg-blue-500 text-white font-bold py-3 px-8 rounded-full transition-all duration-300 transform hover:-translate-y-1 hover:shadow-lg hover:shadow-blue-500/25 active:scale-95 border border-blue-400/20"
                        >
                            Jugar
                        </a>
                    </div>
                </div>

                {/* ESPACIO PARA FUTUROS JUEGOS... */}

            </div>
        </section>
    );
};